import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/layout/Logo";

export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-6 text-center">
      <Logo className="mb-10" />
      <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-brand-light text-primary">
        <Compass className="h-7 w-7" />
      </div>
      <p className="text-sm font-semibold uppercase tracking-[0.2em] text-primary">404</p>
      <h1 className="mt-2 text-3xl font-bold tracking-tight text-foreground">
        Page not found
      </h1>
      <p className="mt-2 max-w-sm text-sm text-muted-foreground">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Button asChild className="mt-8" data-testid="notfound-home-button">
        <Link to="/dashboard">Back to dashboard</Link>
      </Button>
    </div>
  );
}
